import * as _ from 'lodash'
import {SourceTypeBO} from "./SourceTypeBO"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic"
import {PAdbContext} from "../PA.Core/PAdbContext";
import { esWB_SourceType} from "../PA.Core/PAdbSchema";
import {WB_SourceTypeRow} from "../PA.Core/PAdbSchemaRows";
import {toLower} from "lodash";

export class SourceTypeBOValidations {

    static async ValidateFields(aBO: SourceTypeBO): Promise<void> {


        const self = this;
        // Validate ID and Name
        if (_.isEmpty(aBO.WB_SourceType.cif.SOURCE_TYPE_ID) || _.isNull(aBO.WB_SourceType.cif.SOURCE_TYPE_ID)
            || aBO.WB_SourceType.cif.SOURCE_TYPE_ID.trim().length===0) {
            self.addMessage(aBO, 'emptysourcetypeid', 'Source Type ID cannot be empty')

        } else {
            aBO.ValidateMessageProvider.removeMessage('emptysourcetypeid')
        }

        if (_.isEmpty(aBO.WB_SourceType.cif.SOURCE_TYPE_NAME) || _.isNull(aBO.WB_SourceType.cif.SOURCE_TYPE_NAME)
            || aBO.WB_SourceType.cif.SOURCE_TYPE_NAME.trim().length===0) {

            self.addMessage(aBO, 'emptysourcetypename', 'Source Type Name cannot be empty')
        } else {
            aBO.ValidateMessageProvider.removeMessage('emptysourcetypename')
        }

        // Validate Duplicate Names and IDs
        let dbContext = new PAdbContext({})
        let nameRowPresent: any = {}, idRowPresent: any = {}
        let allDuplicateNameRows: any[] = [], allDuplicateIDRows: any[] = []
        let sourceTypeRows = await dbContext.findAll(esWB_SourceType, {where: {DELETED_IND: {neq: '1'}}})
        _.forEach(sourceTypeRows, (row: WB_SourceTypeRow) => {

            if (row.cif.WB_SOURCETYPE_ID !== aBO.WB_SourceType.cif.WB_SOURCETYPE_ID &&
                toLower(row.cif.SOURCE_TYPE_NAME) === toLower(aBO.WB_SourceType.cif.SOURCE_TYPE_NAME)) {
                nameRowPresent = {
                    name: row.cif.SOURCE_TYPE_NAME,
                    id: row.cif.SOURCE_TYPE_ID
                }
                allDuplicateNameRows.push(nameRowPresent)
            }
            if (row.cif.WB_SOURCETYPE_ID !== aBO.WB_SourceType.cif.WB_SOURCETYPE_ID &&
                toLower(row.cif.SOURCE_TYPE_ID) === toLower(aBO.WB_SourceType.cif.SOURCE_TYPE_ID)) {
                idRowPresent = {
                    name: row.cif.SOURCE_TYPE_NAME,
                    id: row.cif.SOURCE_TYPE_ID
                }
                allDuplicateIDRows.push(idRowPresent)
            }
        })


        if (!_.isEmpty(allDuplicateNameRows)) {
            self.addMessage(aBO, "duplicateNames", 'There is an existing Source Type with the same name' +
                '\nSource Type Name:  ' + nameRowPresent?.name +
                '\nSource Type Id: ' + nameRowPresent?.id
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateNames")
        }

        if (!_.isEmpty(allDuplicateIDRows)) {
            self.addMessage(aBO, "duplicateIDs", 'There is an existing Source Type with the same ID' +
                '\nSource Type Name:  ' + idRowPresent?.name +
                '\nSource Type Id: ' + idRowPresent?.id
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateIDs")
        }



        const strRows = _.filter(aBO.WB_SourceType.WB_SourceTypeSTRRows, (r) => r.isActive)

        // Validate that we have at least 1 StrRow
        if(strRows.length==0){
            self.addMessage(aBO, "atleastOneKeyType", 'Add at least one Source Type Key Type row ')

        }else {
            aBO.ValidateMessageProvider.removeMessage("atleastOneKeyType")
        }

        // Validate that each StrRow has non-empty values
        let strRowEmptyValueCheck=false
        _.forEach(strRows, aRow => {
            if(_.isEmpty(aRow.cif.SET_TYPE)|| _.isNull(aRow.cif.SET_TYPE) || _.isEmpty(aRow.cif.INTEGRATION_ALGORITHMS) || _.isNull(aRow.cif.INTEGRATION_ALGORITHMS))
                strRowEmptyValueCheck= true
        })
        if(strRowEmptyValueCheck){
            self.addMessage(aBO, "emptyRowValueCheck", 'Please select values for all rows in the grid')

        }else {
            aBO.ValidateMessageProvider.removeMessage("emptyRowValueCheck")
        }
        //Validate Duplicate KeyTypes
        let keyTypesSet = new Set()
        _.forEach(strRows, strRow => {
            keyTypesSet.add(strRow.cif.SET_TYPE)
        })

        if (strRows.length !== keyTypesSet.size) {
            self.addMessage(aBO, "duplicateKeyTypes", 'Duplicate Key Types are not allowed.')
        }


    }

    private static addMessage(aBO: SourceTypeBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}